import { ReactNode } from "react";
import { TButtonRound } from "../types/design";
import { ClassValue } from "clsx";
import { To } from "react-router-dom";

export interface IMenu {
	label: string;
	icon?: ReactNode;
	itemRound?: TButtonRound;
	className?: ClassValue;
	divider?: boolean;
	setting?: boolean;
	disabled?: boolean;
	isAdminOnly?: boolean;
}

export interface IMenuLink extends IMenu {
	to: To;
	state?: { [x: string]: any };
	replace?: boolean;
}

export const isIMenuLink = (action: any): action is IMenuLink =>
	typeof action.to === "string";

export interface IMenuAtag extends IMenu {
	href: string;
	target?: string;
}

export const isIMenuAtag = (action: any): action is IMenuAtag =>
	typeof action.href === "string";

export interface IMenuButton extends IMenu {
	onClick: (event: any) => void;
	type?: "button" | "submit";
}

export const isIMenuButton = (action: any): action is IMenuButton =>
	typeof action.onClick === "function";

export interface IMenuActions extends IMenu {
	actions: IMenuTypes[];
	hoverable?: boolean;
}

export const isMenuActions = (action: any): action is IMenuActions =>
	action.actions instanceof Array;

export type IMenuTypes = IMenuLink | IMenuButton | IMenuActions;

export interface ISelectOptions {
	value: any;
	label: string;
	others?: any;
	disabled?: boolean;
}

export interface ILoginResponse {
	authuser: string;
	code: string;
	hd: string;
	token_type: string;
	prompt: string;
}

export interface IUser {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	profilePicture: {
		id: string;
		permission: string;
		fileName: string;
		contentType: string;
	};
	role: {
		id: string;
		title: string;
		description: string;
	};
}

export interface IUserList {
	id: string;
	email: string;
	firstName: string;
	lastName: string;
	accountId: string | null;
	departmentId: string | null;
	roleId: string;
	profilePictureId: string;
}

export interface ITimesheets {
	date: string;
	loginTime: string;
	logoutTime: string;
	lateMinutes: number;
	undertimeMinutes: number;
}
